<template>
  <div class="animated revealUp dynamic-voucher-list">
    <div class="section-title">Dynamic Vouchers</div>
    <div class="row">
      <div class="col-12 col-md-4 col-xl-3">
        <div class="input-material">
          <input
            placeholder="Search..."
            type="text"
            v-model="searchValue"
            @input="fetchDynamicVouchers"
            name="search_dv"
            id="search_dv"
          />
        </div>
      </div>
      <div class="col-12 col-md-4 col-xl-3">
        <div class="dropdown-curve-container">
          <div class>
            <multiselect
              v-model="selectedFilter"
              placeholder="Search..."
              id="search_dv"
              name="search_dv"
              :options="activeFilter"
              label="label"
              track-by="value"
              :multiple="false"
              v-validate="'required'"
              @input="fetchDynamicVouchers"
            >
            </multiselect>
          </div>
        </div>
      </div>
      <div>
        <b-button
          variant="default"
          to="add-dynamic-vouchers"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>
    <div class="desg-list-container ny-3">
      <table class="w-100 my-2" style="overflow-x: auto;">
        <thead>
          <tr class="desg-list-header11-dv">
            <th></th>
            <th class="text-left">Dynamic Voucher Title</th>
            <th class="text-left">Voucher Title</th>
            <th class="text-left">Start Date</th>
            <th class="text-left">End Date</th>
            <th>Codes Generated</th>
            <th>Max Codes</th>
            <th>Priority</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody v-if="dynamicVouchers.length">
          <tr
            v-for="(voucher, voucherIndex) in dynamicVouchers"
            :key="voucherIndex"
            class="p-2 h-25"
          >
            <td class="text-center py-2">
              <i
                class="edit-pen icon blue-icon mr-2"
                @click.prevent.stop="onEditDynamicVoucher(voucher.dv_id)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              ></i>
            </td>
            <td class="text-left px-2">{{ voucher.dv_title }}</td>
            <td
              class="text-left px-2 text-blue dv-offer-title"
              @click="handleVoucherRedirection('title', voucher.dv_os_id)"
            >
              {{ voucher.offer_title }}
            </td>
            <td class="text-left px-2">{{ voucher.dv_validity_start }}</td>
            <td class="text-left px-2">{{ voucher.dv_validity_end }}</td>
            <td
              class="text-center px-2 text-blue dv-offer-title"
              @click="handleVoucherRedirection('total_codes', voucher.dv_os_id)"
            >
              {{ voucher.total_codes }}
            </td>
            <td class="text-center px-2">{{ voucher.dv_max_codes }}</td>
            <td class="text-center px-2">{{ voucher.dv_priority }}</td>
            <td class="text-center px-2">
              <StatusDot
                :status="
                  voucher.dv_is_active == 'Y'
                    ? 'active'
                    : voucher.dv_is_active == 'N' && 'inactive'
                "
              />
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr class="desg-list-header11">
            <td colspan="6">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      dynamicVouchers: [],
      searchValue: "",
      activeFilter: [
        { value: "", label: "All" },
        { value: "Y", label: "Active" },
        { value: "N", label: "Inactive" }
      ],
      selectedFilter: { value: "Y", label: "Active" }
    };
  },
  beforeMount() {
    this.fetchDynamicVouchers();
  },
  methods: {
    fetchDynamicVouchers: async function() {
      let loader = this.$loading.show();
      try {
        const response = await MarketingService.fetchDynamicVouchers({
          is_active: this.selectedFilter["value"],
          search_value: this.searchValue
        });

        const { data } = response;

        if (!data.status || !data.Records.length) {
          return this.$toasted.show("No Records found");
        }

        this.dynamicVouchers = data.Records;
      } catch (error) {
        console.log(error);
      } finally {
        loader.hide();
      }
    },
    onEditDynamicVoucher(dv_id) {
      this.$router.push(`/marketing/edit-dynamic-vouchers/${dv_id}`);
    },
    handleVoucherRedirection(type, dv_os_id) {
      if (type == "offer_title") {
        this.$router.push(
          `/marketing/edit-promotions-and-offers-new?os_id=${dv_os_id}`
        );
      } else if (type == "total_codes") {
        this.$router.push(`/marketing/view-voucher-codes-new/${dv_os_id}`);
      }
    }
  }
};
</script>
<style>
.desg-list-header11 th {
  padding: 0 30px;
  border-bottom: 1px solid #d3d3d3;
  -webkit-box-align: center;
  height: 45px;
  text-align: center;
}

table.w-100 tbody tr.desg-list11 td {
  border-bottom: 1px solid var(--lightgrey);
  height: 45px;
  padding: 0 30px;
}

table.w-100 tbody tr.desg-list11:last-child td {
  border-bottom: none;
}

.dynamic-voucher-list .input-material input::placeholder {
  color: gray;
}

.dynamic-voucher-list .dv-offer-title {
  text-decoration: underline;
  cursor: pointer;
}

.desg-list-header11-dv th {
  padding: 0 3px;
  border-bottom: 1px solid #d3d3d3;
  -webkit-box-align: center;
  height: 45px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/getDynamicVouchers.vue